<template>
  <section class="is-small">
    <div class="container">
      <EditArticle />
    </div>
  </section>
</template>

<script>
import EditArticle from '../../components/Article/EditArticle.vue'
export default {
  name: 'PostEdit',

  components: {
    EditArticle
  }
}
</script>

<style lang="scss" scoped>
</style>